// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useDataCode() {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<string>("")

  const refetch = (params: {
    reject_code: string
    date_request: string
    jenis: number
  }): void => {
    api.post(
      "/proreject/generate-received-reject-code",
      params,
      { params }
    ).then((res: SuccessFetch<{
      payload: { next_code: string }
    }>) => {
      setData(res.data.payload.next_code)
    }).catch(() => {
      setData("")
    })
  }

  return { data, refetch }
}